'use strict';

angular.module('teams').factory('TeamsInfo', ['$resource',
	function($resource) {
		return $resource('v1/teams/userTeamsInfo', {}, {
			get: {
				method: 'GET'
			}
		});
	}
]);
